import "./DeleteForm.css";
import React, { useState } from "react";
import PrimaryButton from "../../Atoms/Buttons/Primary/PrimaryButton";
import { Paper } from "@mui/material";
import FormModal from "../FormModal/FormModal";
import DeleteIcon from "@mui/icons-material/Delete";
import { toast } from "react-toastify";
import config from "../../../config";

function DeleteForm({
  setGo = null,
  title = "",
  icon = false,
  setDeleted = null,
  disabled = false,
  error = "",
  id,
  text,
  height,
  padding,
}) {
  const [Open, setOpen] = useState(false);
  return (
    <div style={{ display: "inline-block" }}>
      {icon ? (
        <DeleteIcon
          onClick={() => {
            if (!disabled) setOpen(true);
            else {
              if (error)
                toast.error(error, {
                  position: "top-right",
                  autoClose: 3000,
                  hideProgressBar: false,
                  closeOnClick: true,
                  pauseOnFocusLoss: false,
                  pauseOnHover: true,
                  draggable: true,
                  theme: "colored",
                });
            }
          }}
          sx={{
            color: disabled ? "gray" : "#bf360c",
            cursor: "pointer",
            margin: "0 0 0 5px",
          }}
        />
      ) : (
        <PrimaryButton
          classBtn={"center deleteBtn"}
          text={text ?? "Delete"}
          disabled={disabled}
          click={() => {
            if (!disabled) setOpen(true);
            else {
              if (error)
                toast.error(error, {
                  position: "top-right",
                  autoClose: 3000,
                  hideProgressBar: false,
                  closeOnClick: true,
                  pauseOnFocusLoss: false,
                  pauseOnHover: true,
                  draggable: true,
                  theme: "colored",
                });
            }
          }}
          style={{
            textTransform: "capitalize",
            borderRadius: "5px",
            color: "var(--text-secondary)",
            backgroundColor: disabled ? "gray" : "#D11A2A",
            height: height ?? "30px",
            padding: padding ?? "0 10px",
            cursor: "pointer",
            "&:hover": {
              backgroundColor: disabled ? "gray" : "intaial",
            },
            // margin: "0 20px",
          }}
        />
      )}
      <FormModal
        Open={Open}
        HandleClose={() => setOpen(false)}
        XButton={false}
        Form={
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "space-around",
              marginTop: "15px",
            }}
          >
            <PrimaryButton
              classBtn={"center editButton"}
              text={"Cancel"}
              style={{
                textTransform: "capitalize",
                borderRadius: "5px",
                color: config.SECONDARY_COLOR,
                backgroundColor: config.PRIMARY_COLOR,
                height: "45px",
                padding: "0 30px",
                margin: "0 20px",
              }}
              click={() => {
                setOpen(false);
              }}
            />
            <PrimaryButton
              classBtn={"center editButton deleteBtn"}
              text={"Delete"}
              click={() => {
                if (setGo) setGo(true);
                if (setDeleted) setDeleted(id);
                setOpen(false);
              }}
              style={{
                textTransform: "capitalize",
                borderRadius: "5px",
                color: "var(--text-secondary)",
                backgroundColor: "#D11A2A",
                height: "45px",
                padding: "0 30px",
                margin: "0 20px",
              }}
            />
          </div>
        }
        Title={title}
        CustomStyle={"smallExtra"}
      />
    </div>
  );
}

export default DeleteForm;
